import React from 'react';

export default function InfoIconOutlined() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
			<g fill="none" fillRule="evenodd">
				<g fill="#707578">
					<path
						d="M10 2c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zm0 1.25c-3.728 0-6.75 3.022-6.75 6.75s3.022 6.75 6.75 6.75 6.75-3.022 6.75-6.75S13.728 3.25 10 3.25zM10 9c.552 0 1 .448 1 1v3c0 .552-.448 1-1 1s-1-.448-1-1v-3c0-.552.448-1 1-1zm0-3c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z"
						transform="translate(-1107 -888) translate(1082 799) translate(1 81) translate(24 8)"
					/>
				</g>
			</g>
		</svg>
	);
}
